import React from "react";
import PropTypes from "prop-types";

import Checkbox from "components/Form/Controls/Checkbox";

const PlayerReportItemButtons = ({
    id,
    is_came,
    changeMissedPlayers,
    needReport,
    isOrganizer,
}) => {
    if (isOrganizer && needReport) {
        return (
            <Checkbox
                key={`player-${id}`}
                id={`player-${id}`}
                name={id}
                defaultChecked={true}
                label={` `}
                onChange={changeMissedPlayers}
            />
        );
    }

    if (!needReport) {
        return (
            <>
                <div className="fs-caption c-gs-disabled">
                    {is_came ? "" : "Не пришел"}
                </div>
            </>
        );
    }
    return null;
};

PlayerReportItemButtons.defaultProps = {
    userGroups: [],
    playerGroups: [],
};

PlayerReportItemButtons.propTypes = {
    id: PropTypes.number,
    is_came: PropTypes.bool,
    changeMissedPlayers: PropTypes.func,
    needReport: PropTypes.bool,
    isOrganizer: PropTypes.bool,
    playerGroups: PropTypes.array,
};

export default PlayerReportItemButtons;
